import type { ReactNode } from 'react';
import { clsx } from 'clsx';
import CheckIcon from '../../icons/react/icon-check';
import XIcon from '../../icons/react/icon-x';
import { LoadingSpinner } from '../loading/spinner';
import styles from './button.module.scss';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'light' | 'light-reverse' | 'fancy' | 'rainbow';

export type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large';

export type ButtonState = 'initial' | 'loading' | 'success' | 'error';

export type ButtonAffixIconPosition = 'left' | 'right';

export type ButtonAppearance = 'active' | 'disabled' | 'focused' | 'hovered' | 'selected-radio' | 'enabled' | 'plain';

interface ButtonContentProps {
  affixIcon?: ReactNode;
  affixIconPosition?: ButtonAffixIconPosition;
  children: ReactNode;
  className?: string;
  state?: ButtonState;
}

export function ButtonContent({ affixIcon, affixIconPosition, children, className, state }: ButtonContentProps) {
  return (
    <>
      {state === 'loading' && <LoadingSpinner className={styles.loader} />}
      {state === 'success' && (
        <span className={styles.stateIndicatorContainer}>
          <CheckIcon className={styles.stateIndicator} />
        </span>
      )}
      {state === 'error' && (
        <span className={styles.stateIndicatorContainer}>
          <XIcon className={styles.stateIndicator} />
        </span>
      )}
      <div className={clsx(styles.content, state && state !== 'initial' ? styles.isPlaceholder : undefined, className)}>
        {affixIcon && affixIconPosition === 'left' ? <span className={styles.affixIcon}>{affixIcon}</span> : null}
        {['string', 'number'].includes(typeof children) ? <span>{children}</span> : children}
        {affixIcon && affixIconPosition === 'right' ? <span className={styles.affixIcon}>{affixIcon}</span> : null}
      </div>
    </>
  );
}
